import { render, staticRenderFns } from "./XundianHome.vue?vue&type=template&id=1a9b61e5"
import script from "./XundianHome.vue?vue&type=script&lang=js"
export * from "./XundianHome.vue?vue&type=script&lang=js"
import style0 from "./XundianHome.vue?vue&type=style&index=0&id=1a9b61e5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports